export default __webpack_public_path__ + "alberta-mail.d90840e7e2efdfc4e883.svg";